import { Octicon as Octicon$1 } from '@primer/react/deprecated';
import styled from 'styled-components';
import sx from '../../sx.js';
import { forwardRef } from 'react';
import { jsx } from 'react/jsx-runtime';

/**
 * @deprecated Use the icon component directly from `@primer/octicons-react` instead
 */
const StyledOcticon = styled(Octicon$1).withConfig({
  shouldForwardProp(prop) {
    return prop !== 'sx';
  }
}).withConfig({
  displayName: "Octicon__StyledOcticon",
  componentId: "sc-jtj3m8-0"
})(["", ""], ({
  color,
  sx: sxProp
}) => sx({
  sx: {
    color,
    ...sxProp
  }
}));
const Octicon = /*#__PURE__*/forwardRef(({
  as,
  ...props
}, ref) => {
  return /*#__PURE__*/jsx(StyledOcticon, {
    ...props,
    ...(as ? {
      forwardedAs: as
    } : {}),
    ref: ref
  });
});

export { Octicon, Octicon as default };
